export default {
    CYLINDRICAL: 1,
    SPHERICAL: 2,
};



// WEBPACK FOOTER //
// ./src/Core/Prefab/Panorama/Constants.js